<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content create-alert-form">
  <div class="scroll-wrapper ui basic segment" [ngClass]="{ loading: pending }">
    <div *ngIf="success || error" tamsyMargin marginY="10px">
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
      <esl-message-toast [(message)]="error"></esl-message-toast>
    </div>
    <div class="ui form" [formGroup]="blacklistAddressForm">
      <div class="field section" [ngClass]="displayFieldCss('ipRange')">
        <label class="required">IP Address Range</label>
        <input
          formControlName="ipRange"
          type="text"
          placeholder="Enter ipRange"
        />
        <app-field-error-display
          [displayError]="isFieldValid('ipRange')"
          errorMsg="Please enter range"
        >
        </app-field-error-display>
      </div>

      <div class="field section" [ngClass]="displayFieldCss('reason')">
        <label class="">Description</label>
        <input
          formControlName="reason"
          type="text"
          placeholder="Enter description"
        />
        <app-field-error-display
          [displayError]="isFieldValid('reason')"
          errorMsg="Please select a description"
        >
        </app-field-error-display>
      </div>
    </div>
  </div>
</div>

<div class="actions" style="border: none; background-color: #fff">
  <button class="ui button cancel-modal" (click)="modal.deny(undefined)">
    Cancel
  </button>
  <button
    class="ui primary button"
    [disabled]="!blacklistAddressForm.valid"
    (click)="save()"
    [ngClass]="{ 'yellow loading': pending }"
    autofocus
  >
    Save
  </button>
</div>
